export default __webpack_public_path__ + "static/media/rrhh.5d0db661.png";